import axios from "axios";
import getToken from "../../../config/getToken";
import { convertFileToBase64Dynamic } from "../../../utils/functions";
import { env } from "../../../env";

axios.interceptors.response.use(
  (response) => {
    if (response.data.responseCode === 1016 || response.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Petición para consultar los avisos descargados de Infonavit
 * @param {*} data filtro
 * @returns avisos
 */
export async function GetLocalAvisos(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/filter",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Petición para consultar los avisos directamente en Infonavit
 * @param {*} data filtro
 * @returns avisos
 */
export async function GetDirectAvisos(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/directquery",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Petición para agregar empleados
 * @param {*} data payload
 * @returns respuesta
 */
export async function CreateEmployees(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/register",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Descargar reporte de empleados
 * @param {*} data payload
 * @returns String url
 */
export async function GetEmployeesReport(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "avisos/report",
    data: {
      ...data,
      isHome: false,
    },
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
